// extracted by mini-css-extract-plugin
export default {"badge":"AmountCell_badge__zWiZD","actions":"AmountCell_actions__O6slB","form":"AmountCell_form__MD3EI","input":"AmountCell_input__sD2AA"};